import { __assign } from "tslib";
import React from 'react';
import { Flex, Text, Link } from '@marvelapp/ui';
function SidebarMenuItem(_a) {
    var children = _a.children, onClick = _a.onClick, href = _a.href, keyboardShortcut = _a.keyboardShortcut;
    var anchorProps = href && {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
    };
    return (React.createElement(Link, __assign({ color: "slate", cursor: "pointer", display: "block", fontSize: 2, height: "30px", hoverBg: "snowDark", hoverColor: "licorice", lineHeight: "30px", onClick: onClick }, anchorProps),
        React.createElement(Flex, { alignItems: "center", display: "flex", justifyContent: "space-between", px: 3, width: 1 },
            children,
            keyboardShortcut && (React.createElement(Text, { color: "slate", fontSize: 0, lineHeight: "inherit" }, keyboardShortcut)))));
}
export default SidebarMenuItem;
